import { api } from '@app/api/http.api';
import { ILoginBody } from '@app/interfaces/login';

export const loginRequest = async (body: ILoginBody) => await api.post('/web/admin/user/login-token', body);

export const refreshTokenPath = '/web/admin/user/refresh-token';
export const refreshTokenRequest = async () => await api.get(refreshTokenPath);
